// `avatar scan [--incremental|--full] [--scanners <list>]` — Command 04 spec.
// Runs 5 project scanners and writes proposals to .claude/_pending/.
// Implementation deferred — scanner files in src/scanners/ are stubbed.
import type { Command } from "commander";
import { notImplementedYet } from "../lib/not-implemented-stub.js";

export function registerScanCommand(program: Command): void {
  program
    .command("scan")
    .description("Chạy project scanner và đề xuất knowledge update (M06)")
    .option("--incremental", "Chỉ scan các file thay đổi từ commit cuối")
    .option("--full", "Scan toàn bộ dự án (default)")
    .option("--scanners <list>", "tech-stack,conventions,architecture,domain,git-pattern")
    .option("--background", "Chạy ngầm, ít output")
    .action(notImplementedYet("scan", "Milestone 06"));
}
